import React, { MouseEvent } from "react";
import classNames from "classnames";
import NotificationBell from "components/icons/notification-bell";
import Button from "@material-ui/core/Button";
import Badge from "@material-ui/core/Badge";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { themeOptions } from "styles/theme";
import { Theme } from "@material-ui/core/styles";
import { DATATEST } from "constants/integration";

interface IProps {
    onClick(event: MouseEvent<HTMLButtonElement>): void;
    notice?: boolean;
    className?: string;
    classes?: {
        root?: string;
        badge?: string;
        icon?: string;
    };
    /** Make button styles to be the same as material-ui 0.x for consistency */
    oldStyle?: boolean;
}

export const NotificationButton = ({ onClick, notice = false, classes = {}, className, oldStyle = false }: IProps) => {
    const inner = useStyles({ notice, oldStyle });
    return (
        <Button
            data-test={DATATEST.NOTIFICATIONS_BTN}
            className={classNames(inner.button, className, classes.root)}
            onClick={onClick}
            TouchRippleProps={{ classes: { child: inner.ripple } }}
        >
            <Badge
                classes={{ badge: classNames(inner.badge, classes.badge) }}
                variant="dot"
                invisible={!notice}
                overlap="circle"
            >
                <NotificationBell className={classNames(inner.icon, classes.icon)} />
            </Badge>
        </Button>
    );
};

const useStyles = makeStyles<Theme, { notice: boolean; oldStyle: boolean }>({
    button: ({ oldStyle }) => ({
        minWidth: 24,
        ...(oldStyle && {
            borderRadius: 2,
            "&:hover": {
                backgroundColor: "rgb(153, 153, 153, .2)",
            },
        }),
    }),
    badge: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        backgroundColor: themeOptions.palette.primary1Color,
    },
    icon: ({ notice }) => ({
        width: 24,
        height: 24,
        color: notice ? themeOptions.palette.darkGrey : themeOptions.palette.grey,
    }),
    ripple: ({ oldStyle }) => ({
        backgroundColor: oldStyle ? "rgb(153, 153, 153)" : null,
    }),
});

export default NotificationButton;
